import React from 'react';
import ReactDOM from 'react-dom';
import Main from './components/main';
import './assets/styles/style.css';

ReactDOM.render(<Main />, document.getElementById('root'));
